export default {
  searchStrategy: [
    { label: 'Et', value: 'and' },
    { label: 'Ou', value: 'or' }
  ],
  dateStrategy: [
    { label: 'de', value: 'bt' },
    { label: 'avant', value: 'le' },
    { label: 'après', value: 'ge' },
    { label: 'en', value: 'eq' }
  ],
  numStrategy: [
    { label: 'entre', value: 'bt' },
    { label: 'moins de', value: 'le' },
    { label: 'plus de', value: 'ge' },
    { label: 'égal à', value: 'eq' }
  ],
  textStrategy: [
    { label: 'contient', value: 'cs' },
    { label: 'commence par', value: 'sw' },
    { label: 'finit par', value: 'ew' },
    { label: 'est exactement', value: 'eq' },
    { label: 'ne contient pas', value: 'ncs' },
    { label: 'ne commence pas par', value: 'nsw' },
    { label: 'ne finit pas par', value: 'new' },
    { label: 'est différent de', value: 'neq' },
    { label: 'est renseigné', value: 'nis' }
  ],
  booleanStrategy: [
    { label: 'Oui', value: 'yes' },
    { label: 'Non', value: 'no' }
  ],
  countryStrategy: [
    { label: '', value: 'eq' }
  ],
  exhib_groupStrategy: [
    { label: '', value: 'eq' }
  ],
  genderStrategy: [
    { label: 'Homme', value: 'm' },
    { label: 'Femme', value: 'f' },
    { label: 'Femme-Homme', value: 'fm' }
  ],
  exhibition: [
    {label: 'Titre de l\'exposition ou du catalogue', value: 'title_lower', type: 'text'},
    {label: 'Groupe d\'exposition', value: 'exhibition_group_lower', type: 'exhib_group'},
    {label: 'Année de début de l\'exposition', value: 'begin_year', type: 'date'},
    {label: 'Année de fin de l\'exposition', value: 'end_year', type: 'date'},
    {label: 'Pays actuel', value: 'country_lower', type: 'country'},
    {label: 'Pays de l\'époque', value: 'former_country', type: 'text'},
    {label: 'Ville', value: 'city_lower', type: 'text'},
    {label: 'Itinérante', value: 'traveling', type: 'boolean'},
    {label: 'Source du catalogue', value: 'source_catalog_lower', type: 'text'},
    {label: 'Lieu de l\'exposition', value: 'space_lower', type: 'text'},
    {label: 'Langue du catalogue', value: 'catalog_language_lower', type: 'text'},
    {label: 'Auteurs / Contributeurs au catalogue', value: 'contributor_lower', type: 'text'},
    {label: 'Notes du contributeur à la base Artl@s', value: 'notes_lower', type: 'text'}
  ],
  exhibitor: [
    {label: 'Nom', value: 'name_lower', type: 'text'},
    {label: 'Prénom', value: 'first_name_lower', type: 'text'},
    {label: 'Nationalité', value: 'nationality_lower', type: 'text'},
    {label: 'Ville de naissance', value: 'city_b_lower', type: 'text'},
    {label: 'Pays de naissance', value: 'country_b', type: 'country'},
    {label: 'Ville de résidence', value: 'city_lower', type: 'text'},
    {label: 'Pays de résidence', value: 'country', type: 'country'},
    {label: 'Date de naissance', value: 'year_b', type: 'date'},
    {label: 'Date de décès', value: 'year_d', type: 'date'},
    {label: 'Genre', value: 'gender_lower', type: 'gender'},
    {label: 'Titre de l\'exposition', value: 'exhibition_title_lower', type: 'text'},
    {label: 'Groupe d\'exposition', value: 'exhibition_group_lower', type: 'exhib_group'},
    {label: 'Année de début de l\'exposition', value: 'begin_year', type: 'date'},
    {label: 'Ville de l\'exposition', value: 'exhibition_city_lower', type: 'text'}
  ],
  exhibited_work: [
    {label: 'Titre', value: 'title_lower', type: 'text'},
    {label: 'Nom de l\'artiste', value: 'exhibitor_name_lower', type: 'text'},
    {label: 'Prénom de l\'artiste', value: 'exhibitor_first_name_lower', type: 'text'},
    {label: 'Genre de l\'artiste', value: 'exhibitor_gender_lower', type: 'gender'},
    {label: 'Ville de l\'artiste', value: 'city_e_lower', type: 'text'},
    {label: 'Pays de l\'artiste', value: 'country_e', type: 'country'},
    {label: 'Année d\'exposition', value: 'begin_year_hide', type: 'date'},
    {label: 'Année de conception', value: 'year_c1_hide', type: 'date'},
    {label: 'Ville de conception', value: 'city_c_lower', type: 'text'},
    {label: 'Pays de conception', value: 'country_c_hide', type: 'country'},
    {label: 'Reproduction dans le catalogue', value: 'is_reproduced_in_catalog_hide', type: 'boolean'},
    {label: 'Salle d\'exposition', value: 'space_lower', type: 'text'},
    {label: 'Prix', value: 'price_hide', type: 'text'},
    {label: 'Propriétaire', value: 'owner_lower', type: 'text'},
    {label: 'Ville du propriétaire', value: 'city_o_lower', type: 'text'},
    {label: 'Pays du propriétaire', value: 'country_o_hide', type: 'country'},
    {label: 'Notes', value: 'notes_lower', type: 'text'},
    {label: 'Titre de l\'exposition', value: 'exhibition_title_lower', type: 'text'},
    {label: 'Groupe d\'exposition', value: 'exhibition_group_lower', type: 'exhib_group'},
    {label: 'Ville d\'exposition', value: 'city_ex_lower', type: 'text'},
    {label: 'Pays d\'exposition', value: 'country_ex_hide', type: 'country'}
  ]
}



// WEBPACK FOOTER //
// ./src/lang/fr_FR/options.js